import React, { useRef, useEffect, useState } from 'react'

import { Kings } from './age/kings'
import { AgeText } from './age/agetext'
import { AgeRepresentationText } from './age/agerepresentationtext'
import { AgeGraph } from './age/agegraph'

import { SexRepresentationText } from './sex/sexrepresentationtext'
import { SexGraph } from './sex/sexgraph'

import { PartyRepresentationText } from './party/partyrepresentationtext'
import { PartyGraph } from './party/partygraph'
import { Form } from './form/form'
import { Title } from './utils.tsx';


import './styles.scss'

export const RepresentationLookup = ({ onPlaceChanged }: {onPlaceChanged: any}) => {

  const [userData, setUserData] = useState({
    age: null,
    place: null,
    sex: '',
    party: 'parteilos'
  })

  // const [data, setData] = useState(require(`./141.json`))
  const [data, setData] = useState(null)
  const [highlightedKings, setHighlightedKings] = useState([])

  useEffect(() => {
    if(userData.place != null && (!data || data.bfs != userData.place))
    {
      setHighlightedKings([])
      // fetch(`https://dev-interaktiv.tagesanzeiger.ch/2021/wer-regiert-uns/data/${userData.place}.json?234`)
      fetch(`./data/${userData.place}.json`)
        .then(response => response.json())
        .then(d => {
          setData(d)
          onPlaceChanged(d.name)
        })
    }
  }, [userData])

  if(!data)
  {
    return (
    <div className='representationlookup'>

      <div className='ui vertical colored padded segment'>
        <div className='ui text container'>
          <Form
            userData={userData}
            data={data}
            handleDataChange={(value) => setUserData({...userData, ...value})}
            />
        </div>
      </div>

    </div>
    )
  }

  return (
    <div className='representationlookup'>

      <div className='ui vertical colored padded segment'>
        <div className='ui text container'>
          <Form
            userData={userData}
            data={data}
            handleDataChange={(value) => setUserData({...userData, ...value})}
            />
        </div>
      </div>
      
      {/* <div className='ui vertical segment'>
        <div className='ui text container' style={{color: 'grey', fontSize: '0.8em'}}>
          (Alter: {userData.age}, Ort: {userData.place}, Geschlecht: {userData.sex}, Partei: {userData.party})
        </div>      
      </div> */}

      <div className='ui vertical segment'>
        <div className='ui text container'>

          <h4 className='titlecontet'>Wie Sie in {data.name} repräsentiert werden</h4>

          <SexRepresentationText
            data={data}
            userData = {userData}
          />

          <SexGraph
            data={data}
          />   
        </div>      
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>

          {data.hasages && 
          <>

            <AgeRepresentationText
              data={data}
              userData = {userData}
            />

            <AgeText
              data={data}
            />

          </>}
          {!data.hasages && 
            <>
              <Title>Alter</Title>
              <p>
                Für {data.name} liegen uns keine Angaben zum Alter der Exekutivmitglieder vor.
              </p>

            </>
          }

        </div>
      </div>
      
      {data.hasages && 
        <div className='ui vertical fitted segment mobilefull'>
          
          <div className='ui container'>
            <Kings 
              data={data}
              highlighted={highlightedKings}
              highlightedKingsChanged={e => setHighlightedKings(e)}
            />

            <AgeGraph 
              data={data}
              userData = {userData}
              highlightedKings={highlightedKings}
              highlightedKingsChanged={e => setHighlightedKings(e)}
            />

          </div>
        </div>
      }
      
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <PartyRepresentationText
              data={data}
              userData = {userData}
            />
            
          <PartyGraph
              data={data}
              userData = {userData}
            />

        </div>      
      </div>      

    </div>
  )
}
